import { connect } from 'react-redux';
import AccessSubscriptionGuard from './access-subscription-guard.component';

const mapStateToProps = ({ app }) => ({
  isSubscriptionLoaded: Array.isArray(app.userSubscriptions),
  isEntitlementsLoaded: app.userEntitlements !== null,
});

export default connect(mapStateToProps)(AccessSubscriptionGuard);
